import { Property } from "../../../../global/types";
import { isPropertyInNeighborhood } from "../../utils/listPropertyResolver";

export function isValidLatLng(lat: number, lng: number): boolean {
  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
}

export function getPropertyCoordinates(
  property: Property
): { lat: number; lng: number } | null {
  const lat = parseFloat(property.address.latitude);
  const lng = parseFloat(property.address.longitude);

  if (!isValidLatLng(lat, lng)) {
    return null;
  }

  return { lat, lng };
}

export function getNeighborhoodMappableProperties(
  properties: Property[],
  neighborhood: string
): Property[] {
  return properties.filter(
    (property) =>
      isPropertyInNeighborhood(property, neighborhood) &&
      getPropertyCoordinates(property) !== null
  );
}

export function getNeighborhoodFocusCenter(
  neighborhoodProperties: Property[],
  fallbackCenter: { lat: number; lng: number }
): { lat: number; lng: number } {
  if (neighborhoodProperties.length === 0) {
    return fallbackCenter;
  }

  if (neighborhoodProperties.length === 1) {
    return getPropertyCoordinates(neighborhoodProperties[0])!;
  }

  const totals = neighborhoodProperties.reduce(
    (accumulator, property) => {
      const coordinates = getPropertyCoordinates(property)!;
      return {
        lat: accumulator.lat + coordinates.lat,
        lng: accumulator.lng + coordinates.lng,
      };
    },
    { lat: 0, lng: 0 }
  );

  return {
    lat: totals.lat / neighborhoodProperties.length,
    lng: totals.lng / neighborhoodProperties.length,
  };
}

export function buildNeighborhoodFocusKey(
  neighborhood: string,
  neighborhoodProperties: Property[]
): string {
  if (neighborhoodProperties.length === 0) {
    return `${neighborhood}:pending`;
  }

  const propertyIds = neighborhoodProperties
    .map((property) => property.id)
    .sort((left, right) => left - right)
    .join(",");

  return `${neighborhood}:${propertyIds}`;
}
